import React from 'react';
import { FileText, Download, Printer } from 'lucide-react';

const AssetReports = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-gray-900">Asset Reports</h2>
      {/* Add reports components */}
    </div>
  );
};

export default AssetReports; 